import { useLocation, Link } from 'react-router-dom';
import '../../styles/TyPage.scss';
import logo from "../../assets/logo.png";

const Ty = () => {
  const { search } = useLocation();


  return (
    <div className="ty-container">
      <div className="ty-content">
        <Link to="/">
        <img src={logo} alt="Logo" className="ty-logo" />
        </Link>

        <h2 className="ty-title">Thank you for your purchase!</h2>
        <p className="ty-subtext">
          You're all set!
        </p>
        <p className="ty-confirmation">
          A confirmation has been sent to your email. See you!
        </p>

        <p className='ty-reminder'>
          Please make sure to download your ticket sent to your email.
        </p>
        {/* {transactionId && (
          <button
            onClick={() => downloadPDF(transactionId)}
            className="ty-button"
            disabled={loading}
          >
            {loading ? 'Generating PDF...' : 'Download Ticket'}
          </button>
        )} */}

        {/* <div className="ty-discover">
          <p className="ty-discover-title">Discover more with Gottit!</p>
          <p className="ty-discover-text">
            Sign up for free and explore exclusive products, offers, and more — only on Gottit
          </p>
          <a
            href="https://gottit.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="ty-button"
          >
            Go back to Gottix
          </a>
        </div> */}

        <div className="ty-discover">
          <Link to="/" className="ty-button">
            Go back to Gottix
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Ty;
